type EventHandler<T = any> = (payload?: T) => void;

class EventBus {
  private readonly events = new Map<string, Set<(payload?: any) => void>>();

  emit<T>(event: string, payload?: T) {
    this.events.get(event)?.forEach((handler) => {
      handler(payload);
    });
  }

  on<T>(event: string, handler: EventHandler<T>) {
    if (!this.events.has(event)) {
      this.events.set(event, new Set());
    }

    const wrapped = handler as (payload?: any) => void;
    this.events.get(event)!.add(wrapped);

    return () => {
      this.events.get(event)?.delete(wrapped);
      if (this.events.get(event)?.size === 0) {
        this.events.delete(event);
      }
    };
  }

  once<T>(event: string, handler: EventHandler<T>) {
    const off = this.on<T>(event, (payload) => {
      handler(payload);
      off();
    });
  }
}

/* ================= USAGE =================

LISTEN:
const bus = useEventBus();
useEffect(() => {
  return bus.on('refresh', () => {
    console.log('refresh');
  });
}, []);

EMIT:
useEventBus().emit('refresh');

========================================== */

export const eventBus = new EventBus();
export const useEventBus = () => eventBus;
